import { render, staticRenderFns } from "./PatientOrthoSpace.vue?vue&type=template&id=3723b7ee&"
import script from "./PatientOrthoSpace.vue?vue&type=script&lang=js&"
export * from "./PatientOrthoSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports